const LEGAL_LINKS = Object.freeze([
  Object.freeze({ href: '/privacy.html', label: 'Privacy Policy' }),
  Object.freeze({ href: '/data-deletion.html', label: 'Data Deletion' }),
  Object.freeze({ href: '/terms-of-service.html', label: 'Terms of Service' }),
]);

export default function SiteFooter() {
  return (
    <footer className="bl-site-footer">
      <div className="bl-site-footer__inner">
        <span className="bl-site-footer__company">2026 Estimator App Inc.</span>
        <nav className="bl-site-footer__links" aria-label="Legal">
          {LEGAL_LINKS.map((link) => (
            <a key={link.href} href={link.href}>{link.label}</a>
          ))}
        </nav>
      </div>
    </footer>
  );
}
